import { TypedDocumentNode, gql } from '@apollo/client';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LinkOther } from '@sorare/core/src/atoms/navigation/Box';
import { RepDifference } from '@sorare/core/src/components/rivals/RepDifference';

import {
  isGameFinished,
  isGameLive,
  isGameScheduled,
} from '@sorare/gameplay/src/lib/so5';

import { SetReminder } from 'components/rivals/SetReminder';

import { MyAvailableCards } from './MyAvailableCards';
import { TopRightArea_footballRivalsGame } from './__generated__/index.graphql';

type Props = {
  footballRivalsGame: TopRightArea_footballRivalsGame;
};
export const TopRightArea = ({ footballRivalsGame }: Props) => {
  const { game, myLineup } = footballRivalsGame;

  if (isGameScheduled(game.status)) {
    if (myLineup) {
      return null;
    }

    return (
      <Horizontal gap={1}>
        <MyAvailableCards footballRivalsGame={footballRivalsGame} />
        <LinkOther>
          <SetReminder footballRivalsGame={footballRivalsGame} />
        </LinkOther>
      </Horizontal>
    );
  }

  const {
    myPointsDelta,
    myPotentialPointsDeltaWin,
    myPotentialPointsDeltaLoss,
  } = footballRivalsGame;

  if (
    isGameLive(game.status) &&
    myPotentialPointsDeltaWin !== null &&
    myPotentialPointsDeltaLoss !== null
  ) {
    return (
      <RepDifference
        loss={Math.abs(myPotentialPointsDeltaLoss)}
        win={Math.abs(myPotentialPointsDeltaWin)}
      />
    );
  }
  if (isGameFinished(game.status) && myPointsDelta !== null) {
    return (
      <RepDifference
        win={myPointsDelta > 0 ? Math.abs(myPointsDelta) : null}
        loss={myPointsDelta <= 0 ? Math.abs(myPointsDelta) : null}
      />
    );
  }

  return null;
};

TopRightArea.fragments = {
  footballRivalsGame: gql`
    fragment TopRightArea_footballRivalsGame on FootballRivalsGame {
      slug
      myPointsDelta
      myPotentialPointsDeltaWin
      myPotentialPointsDeltaLoss
      myLineup {
        id
      }
      game {
        id
        status: statusTyped
      }
      ...SetReminder_footballRivalsGame
      ...MyAvailableCards_footballRivalsGame
    }
    ${SetReminder.fragments.footballRivalsGame}
    ${MyAvailableCards.fragments.footballRivalsGame}
  ` as TypedDocumentNode<TopRightArea_footballRivalsGame>,
};
